import { render } from "./DknAlarmTable.vue?vue&type=template&id=219d4d77&ts=true"
import script from "./DknAlarmTable.vue?vue&type=script&lang=ts"
export * from "./DknAlarmTable.vue?vue&type=script&lang=ts"

import "./DknAlarmTable.vue?vue&type=style&index=0&id=219d4d77&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__